const DELIVERY_TYPES = {
  DELIVERY_POINTS: "delivery-points",
  SALESMAN_DELIVERY_POINTS: "salesman-delivery-points",
};

class DeliveryMethodValidator {
  /**
   * @param allDeliveryMethods delivery methods configured for the market
   * @param selectedDeliveryMethod delivery method stored on the deal
   * @param isSalesmanPointAvailable whether the assisted sales delivery point
   *        can still be offered - it is gone once assisted sales get disabled
   *        for the market, even though the delivery method itself stays enabled
   */
  validate(
    allDeliveryMethods,
    selectedDeliveryMethod,
    isSalesmanPointAvailable = true
  ) {
    const result = {
      isDeliveryMethodFound: null,
      isDeliveryMethodEnabled: null,
      isDeliveryPointAvailable: null,
      isSalesmanPointAvailable: null,
    };

    // If no delivery method is selected, don't raise an error
    // Keep in mind that only === false values are considered errors in the basket
    if (!selectedDeliveryMethod || !selectedDeliveryMethod.id) {
      return result;
    }

    const matchingDeliveryMethod = allDeliveryMethods.find(
      ({ id }) => id === selectedDeliveryMethod.id
    );

    result.isDeliveryMethodFound = !!matchingDeliveryMethod;

    if (matchingDeliveryMethod) {
      result.isDeliveryMethodEnabled = matchingDeliveryMethod.enabled;
      // This is just a dummy condition, but if we ever need to check delivery point availability,
      // we can just update this condition..
      if (
        result.isDeliveryMethodEnabled &&
        matchingDeliveryMethod.type === DELIVERY_TYPES.DELIVERY_POINTS
      ) {
        result.isDeliveryPointAvailable = true;
      }

      if (
        result.isDeliveryMethodEnabled &&
        matchingDeliveryMethod.type === DELIVERY_TYPES.SALESMAN_DELIVERY_POINTS
      ) {
        result.isSalesmanPointAvailable = isSalesmanPointAvailable;
      }
    }

    return result;
  }
}

module.exports = DeliveryMethodValidator;
